<template>
	<div class="mt-16 flex flex-col fade-in">
		<span class="self-center text-center text-3xl font-bold text-natural-dark">
			{{ title }}
		</span>
		<Icon name="mdi:check-circle" class="w-32 h-32 text-green-500 mt-8 self-center" />
		<button
			class="ripple-bg-primary text-white font-bold py-5 px-6 rounded-xl w-full mt-12"
			@click="emit('submit')"
		>
			{{ btnTitle }}
		</button>
	</div>
</template>

<script setup lang="ts">
const emit = defineEmits<{
	submit: []
}>()
const props = defineProps<{
	title?: string
	btnTitle?: string
}>()
</script>
